import { makeActionCreator } from "redux-toolbelt";

const makeTabsEventPageAction = makeActionCreator.withDefaults({
  prefix: "ui/tabs/event_page/",
});

export const switchTab = makeTabsEventPageAction("SWITCH_TAB");
